import { Section } from '../../views/sections/builders/section_builder';
import { ISectionRegistrationAttributesDatasource } from '../datasources/section_registration_attributes_datasource';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export type RemoveSectionsRegistrationAttributesCommand = (sectionIds: Array<Section['id']>) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'removeSectionsRegistrationAttributesCommand',
    (
      defineCommandORM: IDefineCommand,
      ngSectionRegistrationAttributesDatasource: ISectionRegistrationAttributesDatasource
    ) => {
      return defineCommandORM(
        'removeSectionsRegistrationAttributesCommand',
        (deferred, sectionIds: Array<Section['id']> = []) => {
          sectionIds.forEach((sectionId) => {
            const section = ngSectionRegistrationAttributesDatasource.get(sectionId);
            if (section) {
              ngSectionRegistrationAttributesDatasource.del(sectionId);
            }
          });
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/commands/remove_section_registration_attributes_command.ts